import React, { useState } from "react";
import { useSelector } from "react-redux";

import Loading from "../../../../Components/Interactive/Loading";
// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import CustomerLockoutsTable from "./CustomerLockouts/CustomerLockoutsTable";

const CustomerLockoutsWidget = ({ allCustomerData, setTrigger, loading }) => {
  // Get userId
  const userAuth = useSelector((state) => state.auth);
  
  const {
    userLockouts: { lockouts },
  } = allCustomerData;
  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <>
          <div className="customer-widget-header">
            <p
              className="customer-widget-heading"
              style={{ width: "100%", padding: ".5rem .5rem" }}
            >
              Customer Lockouts
              <ArrowDropDownIcon
                onClick={() => {
                  setIsOpen(!open);
                  setToggleDropdown(!toggleDropdown);
                }}
                className={`arrow-dropdown ${
                  toggleDropdown ? "arrow-open" : "arrow-close"
                }`}
              />
            </p>
            {!open && (
              <p className="closed-details-text"
              >
                Total Lockouts - {lockouts.length}
              </p>
            )}
          </div>
          <div
            className={`${
              open ? "show-data-table-call" : "no-data-table-call"
            }`}
          >
            {lockouts && lockouts?.length >= 0 && (
              <CustomerLockoutsTable
                lockoutData={lockouts}
                totalLockouts={lockouts.length}
                setTrigger={setTrigger}
                userId = {userAuth.userInfo.userData.userId}
                role = {userAuth.userInfo.userData.role}
                open={open}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default CustomerLockoutsWidget;
